import React, {Component} from 'react';
import {Redirect} from 'react-router';

import {Link} from 'components/ReactRouterDomLocalized';
import Registry from 'registry';

import {Form, InputWrapper} from 'form';
import {t} from 'l10n';
import {registerUser} from 'backend-helpers/member';
import SubmitWrapper from 'components/form/SubmitWrapper';
import GenderSelect from 'components/common/GenderSelect';

export default class ModalMenuSignupForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pending: false,
            done: false,
            captchaToken: null,
            captchaError: ''
        };

        this.captchaRef = React.createRef();
        this.captchaWidgetId = null;
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && window.ageverif) {
            window.ageverif.start();
        }

        if (typeof window === 'undefined') return;

        let intervalId = null;

        const initCaptcha = () => {
            if (this.captchaRef.current && window.turnstile) {
                this.captchaWidgetId = window.turnstile.render(this.captchaRef.current, {
                    sitekey: '0x4AAAAAACYQvImRXMQ5dwGT',
                    callback: (token) => {
                        this.setState({
                            captchaToken: token,
                            captchaError: ''
                        });
                    },
                    'expired-callback': () => {
                        this.setState({ captchaToken: null });
                    }
                });

                clearInterval(intervalId);
            }
        };

        intervalId = window.setInterval(initCaptcha, 100);

        this._intervalCleanup = () => clearInterval(intervalId);
    }

    componentWillUnmount() {
        if (this._intervalCleanup) this._intervalCleanup();

        if (window.turnstile && this.captchaWidgetId !== null) {
            window.turnstile.remove(this.captchaWidgetId);
        }
    }

    resetCaptcha() {
        if (!window.turnstile || this.captchaWidgetId === null) return;

        window.turnstile.reset(this.captchaWidgetId);

        this.setState({
            captchaToken: null,
            captchaError: ''
        });
    }

    onSubmit(formData, setErrors) {
        if (!this.state.captchaToken) {
            this.setState({ captchaError: t('Please confirm you are not a robot') });
            this.resetCaptcha();
            return;
        }

        this.setState({ pending: true });

        registerUser({
            ...formData,
            captcha: this.state.captchaToken
        })
            .then((response) => {
                this.resetCaptcha();
                this.props.onRegisterSuccess(response);
                this.setState({ done: true });
            })
            .catch((error) => {
                this.resetCaptcha();
                this.setState({
                    pending: false
                });

                setErrors(error.messages || error.message, true);
            });
    }

    render() {
        if (this.state.done) return <Redirect to="/?confirm_registration"/>;

        let debug_nick, debug_email, debug_password;

        if(Registry.get('DEBUG_FORMS', false)) {
            debug_nick = 'bobweb' + Math.floor(Math.random() * 1000);
            debug_email = "bobvoyeurweb+" + debug_nick + "@gmail.com";
            debug_password = "passe";
        }

        return (
            <div>
                <p className="name">
                    <span>{t('Sign up')}</span>
                    <Link to="/?login" className="header-button">{t('Log in')}</Link>
                </p>
                <Form onSubmit={this.onSubmit}>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="nick" type="text" placeholder={t('Nick')} defaultValue={debug_nick} />
                    </div>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="email" type="email" placeholder="Email" defaultValue={debug_email} forceHtml/>
                    </div>
                    <div className="space-between">
                        <GenderSelect name="gender" />
                    </div>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="password" type="password" placeholder={t('Password')} defaultValue={debug_password} />
                    </div>
                    <div className="space-between">
                        <InputWrapper data-formfield={true} name="password_confirm" type="password" placeholder={t('Confirm password')} defaultValue={debug_password} />
                    </div>
                    <div ref={this.captchaRef} style={{ margin: '10px 0' }} />

                    {this.state.captchaError && (
                        <div className="form-error" style={{ marginBottom: '10px', color: 'white', fontSize: '12px' }}>
                            {this.state.captchaError}
                        </div>
                    )}
                    <div>
                        <SubmitWrapper className="btn-submit" value={t('Enter')} pending={this.state.pending}/>
                    </div>
                </Form>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuSignupForm.js